<template>
  <div
    class="col-12 stationTable customFooBTableArea"
    :class="[isAResponsiveTable ? 'customResponsiveTableArea' : null, customClass, isFullSearch ? 'clearMarginTop36Px' : null]"
  >
    <!-- table search start -->
    <div class="row">
      <div v-if="headerSlotsArea" class="dataTableInput" :class="[!moreButton ? 'col-xl-6 col-lg-8 col-md-7 col-sm-8' : 'col-auto', detailClass]">
        <slot v-if="moreButton" name="moreButton" />
        <div class="row customRow15">
          <div class="customPadding15 selectOfListTable" :class="selectSlotClass ? selectSlotClass : 'col-6'">
            <slot name="baseSelect" />
          </div>
          <div class="customPadding15 selectOfListTable" :class="selectSlotClassTwo ? selectSlotClassTwo : 'col-6'">
            <slot name="baseSelectTwo" />
          </div>
        </div>
      </div>
      <div
        v-if="isSearchBoxAndExcelActive"
        :class="[
          !moreButton ? (isFullSearch ? 'col-12' : 'col-xl-auto col-lg-4 col-md-auto col-sm col ml-auto') : 'col-sm',
          searchClass,
          isFullSearch ? 'col-12' : null,
        ]"
      >
        <div class="row no-gutters align-items-center justify-content-end">
          <div v-if="isPDFDownloadActive" class="col-sm-auto col">
            <button type="button" class="btn downloadButton m-0 mr-3 pdfButton">
              <img src="../../public/src/images/pdf-2-svgrepo-com.svg" alt="pdf-2-svgrepo" />
              {{ isPDFDownloadText }}
            </button>
          </div>
          <div v-if="isPDFDownloadActive2" class="col-sm-auto col">
            <button type="button" class="btn downloadButton m-0 mr-3 pdfButton">
              <img src="../../public/src/images/pdf-2-svgrepo-com.svg" alt="pdf-2-svgrepo" />
              {{ isPDFDownloadText2 }}
            </button>
          </div>
          <div v-if="isExcelDownloadActive" class="col-sm-auto col">
            <button type="button" class="btn downloadButton m-0 mr-3" data-toggle="modal" data-target="#excelModal">
              Excel İndir
              <i class="fas fa-file-download downloadButton" />
            </button>
          </div>
          <div v-if="customHtmlElement" class="col-auto">
            <slot name="customHtmlElement" />
          </div>
          <div v-if="isSearchBoxActive" :class="isFullSearch ? 'col-12' : 'col-sm-auto col'">
            <base-input id="filter-input" :placeholder="'Arama'" :input-class="'fooTableFilterInput'" @input.native="setSearchModel($event)" />
          </div>
        </div>
      </div>
    </div>
    <!-- table search end -->
    <div class="row">
      <div class="col-12">
        <div class="darkBlueGreyTable customBFooTable">
          <b-table
            id="my-table"
            ref="fooTable"
            :striped="striped"
            :borderless="borderless"
            :items="filteredItems"
            :fields="filteredFields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filterTableInputSearch"
            :thead-tr-class="theadTrClass"
            :class="tableClass"
            :hover="hover"
            :empty-filtered-text="emptyFilteredText"
            :empty-text="emptyText"
            :show-empty="showEmpty"
            :responsive="responsive"
            :fixed="fixed"
            :sort-compare="customSorting"
            :filter-included-fields="filterIncludedFields"
            :filter-debounce="300"
            :filter-function="filterTable"
            :sticky-header="stickyHeader"
            :no-border-collapse="noBorderCollapse"
            :sort-by.sync="computedSortBy"
            :sort-desc.sync="computedSortDesc"
            :select-mode="selectMode"
            :selectable="selectable"
            :tbody-tr-class="tbodyTrClass"
            @row-clicked="selectedEntityRowClicked"
            @row-selected="selectedEntityRowClicked"
            @filtered="onFiltered"
          >
            <!-- body  -->
            <template v-for="(column, columnIndex) in tableColumnsData" #[`cell(${column.name})`]="data">
              <template v-if="column.isASelectCheckBox && hasASelectableProp(data.item)">
                <div :key="'column' + columnIndex" class="form-check pl-0 relativeChekBox">
                  <label class="checkboxArea align-items-center">
                    <span class="checkboxText">{{ data.item[column.name] | inputToUpperCase }}</span>
                    <input
                      type="checkbox"
                      :value="data.item"
                      :aria-label="'tableCheckbox' + columnIndex"
                      :checked="isItChecked(data.item)"
                      @change="selectEntity(data)"
                    />
                    <span class="checkmark" />
                  </label>
                </div>
              </template>
              <template v-else-if="column.isASelectCheckBox && !hasASelectableProp(data.item)">
                {{ getColumnValue(data.item, column.name) | inputToUpperCase }}
              </template>
              <div v-else-if="column.isARadioCheckInput && selectMode === 'single'" :key="'column' + columnIndex" class="d-flex align-items-center">
                <span v-if="bTableWidth < 1200 && rowDetails.length > 0" class="d-flex">
                  <i :class="data.detailsShowing ? 'btnTableMinus' : 'btnTablePlus'" @click="btnToggleDetails(data)" />
                </span>
                <div v-if="column.isARadioCheckInput && hasASelectableProp(data.item)" class="form-check pl-0 d-inline-block">
                  <div class="radioBtnArea">
                    <input v-model="selected" type="radio" :aria-label="'tableRadioInput' + columnIndex" name="radio" :value="data.item" />
                    <span class="radioCheckmark" />
                    <span class="radioBtnText">{{ data.item[column.name] | inputToUpperCase }}</span>
                  </div>
                </div>
                <template v-else-if="column.isARadioCheckInput && !hasASelectableProp(data.item)">
                  {{ getColumnValue(data.item, column.name) | inputToUpperCase }}
                </template>
              </div>
              <entity-status
                v-else-if="column.isAStatus"
                :key="'column' + columnIndex"
                :page-name="enumHelper[pageName]"
                :get-entity-status-props="getEntityStatus(data.item)"
              />

              <button
                v-else-if="column.isAHistory"
                :key="'column' + columnIndex"
                type="button"
                :aria-label="'btnHistory' + columnIndex"
                class="btn btn-icon-history"
                @click="selectedEntityHistory(data.item)"
              >
                <i class="fa fa-undo" />
              </button>

              <template v-else-if="column.isADetailButton">
                <slot name="detailButtonForPersonelAccountClosingView" :selected-row="data.item" />
              </template>

              <template v-else-if="column.isACurrency">
                {{ toCurrencyValue(data.item, column.name) | inputToUpperCase }}
              </template>

              <template v-else-if="column.areHaveUpdateAndDeleteButton">
                <slot name="updateAndDeleteButton" :selected-row="data.item" />
              </template>

              <template v-else-if="column.customCellArea">
                <slot name="customCellArea" :selected-row="data.item" />
              </template>

              <template v-else-if="column.customCellAreaTwo">
                <slot name="customCellAreaTwo" :selected-row="data.item" />
              </template>

              <template v-else>
                {{ getColumnValue(data.item, column.name) | inputToUpperCase }}
              </template>
            </template>
            <template #emptyfiltered="{ emptyFilteredText }">
              <div class="text-center">
                <p class="m-0">{{ emptyFilteredText | inputToUpperCase }}</p>
              </div>
            </template>
            <template #empty="{ emptyText }">
              <div class="text-center">
                <p class="m-0">{{ emptyText | inputToUpperCase }}</p>
              </div>
            </template>

            <!-- details -->

            <template v-if="bTableWidth < 1200 && rowDetails.length > 0" #row-details="row">
              <ul class="detailsUL row">
                <template v-for="(rowDetail, rowDetailIndex) in rowDetails">
                  <li v-if="rowDetail.width >= bTableWidth" :key="'rowDetail' + rowDetailIndex" class="col-12">
                    <div v-if="rowDetail.isAHistory" class="row">
                      <span class="col-auto font-weight-bold">Geçmiş:</span>
                      <span class="col d-flex">
                        <button type="button" class="btn btn-icon-history" aria-label="btnHistory" @click="selectedEntityHistory(row.item)">
                          <i class="fa fa-undo" />
                        </button>
                      </span>
                    </div>
                    <div v-else-if="rowDetail.isAStatus" class="row">
                      <span class="col-auto font-weight-bold">Durum:</span>

                      <span class="col d-flex">
                        <entity-status :page-name="enumHelper[pageName]" :get-entity-status-props="getEntityStatus(row.item)" />
                      </span>
                    </div>
                    <div v-else class="row">
                      <span class="col-auto font-weight-bold">{{ rowDetail.title | inputToUpperCase }}:</span>
                      <span class="col d-flex">{{ getColumnValue(row.item, rowDetail.name) | inputToUpperCase }}</span>
                    </div>
                  </li>
                </template>
              </ul>
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-auto selectNoBorder">
        <multi-select-wrapper
          v-model="perPageCopy"
          :options="pageOptions"
          :text-field="'text'"
          :value-field="'value'"
          :placeholder="`1-${perPage} Arası`"
          :searchable="true"
          :internal-search="true"
          @input="handlePerPageSelectValue($event)"
        />
      </div>

      <div class="col pageNavigation">
        <b-pagination
          v-model="currentPageCopy"
          :total-rows="totalRows"
          :per-page="perPage"
          size="sm"
          :limit="limitPagination"
          :first-number="firstNumberPagination"
          :last-number="lastNumberPagination"
          aria-controls="my-table"
          @page-click="paginationResetWorkFlow"
        >
          <template #prev-text>
            <a class="page-link">
              <span><i class="navigationArrowLeft" /></span>
            </a>
          </template>
          <template #next-text>
            <a class="page-link">
              <span><i class="navigationArrowRight" /></span>
            </a>
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import BaseInput from "./element/form/input/BaseInput.vue";
import commonEntityProperties from "../mixins/commonEntityProperties";
import EntityStatus from "./list-pages/EntityStatus.vue";
import enumHelper from "../util/enumHelper";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import currencyMixin from "../mixins/currencyMixin";
import MultiSelectWrapper from "./element/form/select/MultiSelectWrapper.vue";

Vue.component("DownloadExcel", JsonExcel);

export default {
  name: "FooTable",
  components: { MultiSelectWrapper, EntityStatus, BaseInput },
  filters: {
    inputToUpperCase(event) {
      if (typeof event === "string" && event) {
        return event.toLocaleUpperCase("tr-TR");
      } else {
        return event;
      }
    },
  },
  mixins: [commonEntityProperties, currencyMixin],
  props: {
    tableColumnsData: {
      type: Array,
      default: () => [],
    },
    rowDetails: {
      type: Array,
      default: () => [],
    },
    pageName: {
      type: String,
      default: "",
    },
    bTableWidth: {
      type: Number,
      default: 0,
    },
    totalRows: {
      type: Number,
      default: 1,
      required: true,
    },
    filteredItems: {
      type: Array,
      default: () => [],
      required: true,
    },
    filteredFields: {
      type: Array,
      default: () => [],
      required: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
    theadTrClass: {
      type: String,
      default: "bgDarkBlueGrey",
    },
    tableClass: {
      type: String,
      default: null,
    },
    hover: {
      type: Boolean,
      default: true,
    },
    responsive: {
      type: [String, Boolean],
      default: true,
    },
    fixed: {
      type: Boolean,
      default: true,
    },
    emptyFilteredText: {
      type: String,
      default: "Aradığınız kayıt bulunamadı.",
    },
    emptyText: {
      type: String,
      default: "Kayıt bulunamadı.",
    },
    showEmpty: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    limitPagination: {
      type: Number,
      default: 10,
    },
    firstNumberPagination: {
      type: Boolean,
      default: true,
    },
    lastNumberPagination: {
      type: Boolean,
      default: true,
    },
    filterIncludedFields: {
      type: Array,
      default: () => [],
    },
    isAResponsiveTable: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: null,
    },
    headerSlotsArea: {
      type: Boolean,
      default: true,
    },
    moreButton: {
      type: Boolean,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      default: false,
    },
    noBorderCollapse: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      type: String,
      default: "lastUpdateDate",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
    selectSlotClass: {
      type: String,
      default: null,
    },
    selectSlotClassTwo: {
      type: String,
      default: null,
    },
    isSearchBoxAndExcelActive: {
      type: Boolean,
      default: true,
    },
    isExcelDownloadActive: {
      type: Boolean,
      default: true,
    },
    isSearchBoxActive: {
      type: Boolean,
      default: true,
    },
    selectMode: {
      type: String,
      default: "single",
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    detailClass: {
      type: String,
      default: null,
    },
    searchClass: {
      type: String,
      default: null,
    },
    isFullSearch: {
      type: Boolean,
      default: false,
    },
    selectedPropNameForCheckbox: {
      type: String,
      default: "id",
    },
    isPDFDownloadActive: {
      type: Boolean,
      default: false,
    },
    isPDFDownloadActive2: {
      type: Boolean,
      default: false,
    },
    isPDFDownloadText: {
      type: String,
      default: "PDF İndir",
    },
    isPDFDownloadText2: {
      type: String,
      default: "PDF İndir",
    },
    customHtmlElement: {
      type: Boolean,
      default: false,
    },
    tbodyTrClass: {
      type: Function,
      default: () => () => "",
    },
  },

  data() {
    return {
      pageOptions: [
        { value: 30, text: "1-30 Arası" },
        { value: 50, text: "1-50 Arası" },
      ],
      filterTableInputSearch: "",
      selected: "",
      sortByInternal: "lastUpdateDate",
      sortDescInternal: true,
    };
  },
  computed: {
    enumHelper() {
      return enumHelper;
    },
    currentPageCopy: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.$emit("update:currentPage", value);
      },
    },
    perPageCopy: {
      get() {
        return this.perPage;
      },
      set(value) {
        this.$emit("update:perPage", value);
      },
    },
    computedSortBy: {
      get() {
        return this.sortBy || this.sortByInternal;
      },
      set(value) {
        this.sortByInternal = value;
      },
    },
    computedSortDesc: {
      get() {
        return this.sortDesc || this.sortDescInternal;
      },
      set(value) {
        this.sortDescInternal = value;
      },
    },
  },
  created() {
    if (this.perPage !== 50 || this.perPage !== 30 || this.perPage !== 10) {
      this.pageOptions.push({ value: this.perPage, text: `1-${this.perPage} Arası` });
      this.pageOptions.sort((a, b) => a.value - b.value);
    }
    this.$_timeout = null;
  },
  beforeDestroy() {
    clearTimeout(this.$_timeout);
  },
  methods: {
    hasASelectableProp(item) {
      if (item.selectable === undefined) {
        return true;
      } else {
        return item.selectable;
      }
    },
    translateAccountStatusToTurkish(val) {
      if (val === "OPEN") {
        return "AÇIK";
      } else if (val === "CLOSE") {
        return "KAPALI";
      } else if (val === "WAITING_APPROVEL") {
        return "ONAY BEKLİYOR";
      } else if (val === "APPROVED") {
        return "ONAYLANDI";
      } else if (val === "TRANSFERRED") {
        return "KAPALI";
      } else if (val === "SYSTEM_TRANSFERRED") {
        return "KAPALI";
      } else if (val === null) {
        return " ";
      } else {
        return "KAPALI";
      }
    },
    translateApprovalStatusToTurkish(val) {
      if (val === "OPEN") {
        return "AÇIK";
      } else if (val === "CLOSE") {
        return "KAPALI";
      } else if (val === "WAITING_APPROVEL") {
        return "ONAY BEKLİYOR";
      } else if (val === "APPROVED") {
        return "ONAYLANDI";
      } else if (val === "TRANSFERRED") {
        return "ONAYLANDI";
      } else if (val === "SYSTEM_TRANSFERRED") {
        return "KAPALI";
      } else if (val === null) {
        return " ";
      } else {
        return "KAPALI";
      }
    },
    getColumnValue(dataItem, columnName) {
      switch (columnName) {
        case "lastUpdateDate":
          return dataItem[columnName] ? moment(dataItem[columnName]).add(3, "hour").format("DD.MM.YYYY HH:mm") : "TARİH YOK";
        case "trainLastDate":
          return dataItem[columnName] ? moment(dataItem[columnName]).format("DD.MM.YYYY") : "TARİH YOK";
        case "creationTime":
          return dataItem[columnName] ? moment(dataItem[columnName]).format("DD.MM.YYYY HH:mm:ss") : "TARİH YOK";
        case "user":
          return dataItem[columnName] ? dataItem[columnName].toLocaleUpperCase("tr-TR") : "DEMO KULLANICI";
        case "userId":
          return dataItem[columnName] ? (dataItem[columnName] === 0 ? "DEMO KULLANICI" : dataItem[columnName].toLocaleUpperCase("tr-TR")) : "DEMO KULLANICI";
        case "characteristic":
          return dataItem[columnName] ? "EVET" : "HAYIR";
        default:
          if (dataItem[columnName]) {
            return typeof dataItem[columnName] === "string" ? dataItem[columnName].toLocaleUpperCase("tr-TR") : dataItem[columnName];
          } else {
            return "-";
          }
      }
    },
    toCurrencyValue(dataItem, columnName) {
      return this.formatCurrencyForInput(dataItem[columnName]);
    },
    filterTable(rowObject, searchText) {
      for (let i = 0; i < this.filterIncludedFields.length; i++) {
        if (rowObject[this.filterIncludedFields[i]]) {
          if (rowObject[this.filterIncludedFields[i]].toString().toLocaleUpperCase("tr-TR").indexOf(searchText.toLocaleUpperCase("tr-TR")) !== -1) {
            return true;
          }
        }
      }
    },
    setSearchModel(event) {
      clearTimeout(this.$_timeout);
      this.$_timeout = setTimeout(() => {
        Vue.set(this, "filterTableInputSearch", event.target.value);
      }, 300); // set this value to your preferred debounce timeout
    },
    selectedEntityHistory(row) {
      this.$emit("selectedEntityHistory", row);
      this.selectedEntityRowClicked(row);
    },
    customSorting(a, b, key) {
      if (key === "date" && typeof a[key] === "string" && typeof b[key] === "string") {
        // Convert the string formatted date to a number that can be compared
        // Get the values being compared from the items
        let firstValue = a[key];
        let secondValue = b[key];

        let separator = "-";
        if (firstValue.includes("/") && secondValue.includes("/")) {
          separator = "/";
        }
        // Split them into an array of parts (dd, mm, and yyyy)
        firstValue = firstValue.split(separator);
        secondValue = secondValue.split(separator);
        // convert string parts to numbers
        firstValue = parseInt(firstValue[2], 10) * 10000 + parseInt(firstValue[1], 10) * 100 + parseInt(firstValue[0]);
        secondValue = parseInt(secondValue[2], 10) * 10000 + parseInt(secondValue[1], 10) * 100 + parseInt(secondValue[0]);
        // Return the comparison result
        return firstValue - secondValue;
      } else if (key === "dateRange") {
        let separator = "-";
        let firstValue = a[key];
        let secondValue = b[key];
        firstValue = firstValue.split(separator)[0].replaceAll(" ", "");
        secondValue = secondValue.split(separator)[0].replaceAll(" ", "");

        const parseDate = (dateStr) => {
          const [day, month, year] = dateStr.split(".");
          return new Date(`${year}-${month}-${day}`);
        };

        const dateA = parseDate(firstValue);
        const dateB = parseDate(secondValue);
        // If both compared fields are native numbers
        return dateA < dateB ? -1 : dateA > dateB ? 1 : 0;
      } else if (typeof a[key] === "number" && typeof b[key] === "number") {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
      } else if (a[key] instanceof Date && b[key] instanceof Date) {
        return a[key] - b[key];
      } else {
        // Stringify the field data and use String.localeCompare
        return this.toStringMthod(a[key]).localeCompare(this.toStringMthod(b[key]), undefined, {
          numeric: true,
        });
      }
    },
    toStringMthod(value) {
      if (!value) {
        return "";
      } else if (value instanceof Object) {
        return Object.keys(value)
          .sort()
          .map((key) => toString(value[key]))
          .join(" ");
      }
      return String(value);
    },
    onFiltered(onFilteredItems) {
      this.$emit("onFiltered", onFilteredItems);
    },
    selectedEntityRowClicked(selectedEntity) {
      this.$emit("selectedEntityRowClicked", selectedEntity);
      Vue.set(this, "selected", selectedEntity);
    },
    paginationResetWorkFlow() {
      this.$emit("paginationResetWorkFlow");
      Vue.set(this, "selected", null);
    },
    btnToggleDetails(item) {
      item.toggleDetails();
      item.detailsShowing = !item.detailsShowing;
    },
    selectEntity(data) {
      if (this.$refs.fooTable.isRowSelected(data.index)) {
        this.$refs.fooTable.unselectRow(data.index);
      } else {
        this.$refs.fooTable.selectRow(data.index);
      }
    },
    isItChecked(item) {
      if (!Array.isArray(this.selected)) return false;
      return !!this.selected.find((selectedEntity) => selectedEntity[this.selectedPropNameForCheckbox] === item[this.selectedPropNameForCheckbox]);
    },
    handlePerPageSelectValue(event) {
      if (!event) {
        this.perPageCopy = 10;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customFooBTableArea {
  &.clearMarginTop36Px {
    .table-responsive {
      margin-top: 0 !important;
    }
  }
}

.radioBtnArea {
  width: 100% !important;
}

.pdfButton {
  margin-bottom: 16px !important;
  display: flex;
  align-items: center;

  img {
    margin-right: 8px;
  }
}
</style>
